import React from "react";
import { Box } from "@mui/material";
import { useMilestoneContext } from "../context/MilestoneContext";
import MilestoneAccordion from "./MilestoneAccordion";
import { milestoneStyles } from "../styles/milestoneStyles";
import { getMilestoneId } from "../utils/milestoneUtils";

// Optimized milestone list component with React.memo
const MilestoneListComponent: React.FC = () => {
     const {
          combinedMilestoneData,
          expandedAccordions,
          selectedMilestones,
          taskStates,
          getTasksForMilestone,
          handleCheckboxChange,
          handleTaskCheckboxChange,
          handleMenuClick,
          toggleAccordion,
          exceptionCount,
          alertsCount,
          notesCount,
          isNotApplicableMilestone,
          updateMilestoneTasks,
          automatedTasks,
          saleDate,
          closeOfEscrowActual,
          closeOfEscrowEstimated,
          setMilestoneTab,
          userInfo,
          homeSiteId,
          divisionCode
     } = useMilestoneContext();

     return (
          <Box sx={milestoneStyles.scrollableContent}>
               {combinedMilestoneData.length > 0 &&
                    combinedMilestoneData?.map((milestone) => {
                         const milestoneId = getMilestoneId(milestone);
                         return (
                              <MilestoneAccordion
                                   key={milestoneId}
                                   milestone={milestone}
                                   expanded={(() => {
                                        const isExpanded = expandedAccordions[milestoneId] || false;
                                        return isExpanded;
                                   })()}
                                   toggleAccordion={toggleAccordion}
                                   selectedMilestones={selectedMilestones}
                                   exceptionCounts={exceptionCount}
                                   alertsCounts={alertsCount}
                                   notesCounts={notesCount}
                                   handleCheckboxChange={handleCheckboxChange}
                                   handleMenuClick={handleMenuClick}
                                   taskStates={taskStates}
                                   handleTaskCheckboxChange={handleTaskCheckboxChange}
                                   getTasksForMilestone={getTasksForMilestone}
                                   userId={userInfo.username}
                                   isNotApplicableMilestone={isNotApplicableMilestone}
                                   updateMilestoneTasks={updateMilestoneTasks}
                                   automatedTasks={automatedTasks}
                                   saleDate={saleDate}
                                   closeOfEscrowActual={closeOfEscrowActual}
                                   closeOfEscrowEstimated={closeOfEscrowEstimated}
                                   setMilestoneTab={setMilestoneTab}
                                   homeSiteId={homeSiteId}
                                   divisionCode={divisionCode}
                              />
                         );
                    })}
          </Box>
     );
};

// Memoize the component with custom comparison
export const MilestoneList = React.memo(MilestoneListComponent);
MilestoneList.displayName = 'MilestoneList'; 